import { statusMeta, statusOf } from "@/lib/invoice";

export const StatusBadge = ({ invoice }) => {
  const meta = statusMeta(statusOf(invoice));
  return (
    <span
      data-testid={`status-badge-${meta.label.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 font-mono text-[11px] uppercase tracking-wider ${meta.cls}`}
    >
      {meta.label}
    </span>
  );
};
